(() => {
  const config = document.querySelector('[data-nab-motion-script]').dataset;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const strips = new Map();
  const pictures = new Map();
  const visible = element => {
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
  };
  const arrow = direction => `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${direction === 'next' ? 'M5 12h14m-6-6 6 6-6 6' : 'M19 12H5m6-6-6 6 6 6'}"/></svg>`;
  const pauseIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5v14M15 5v14"/></svg>';
  const playIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 10 7-10 7Z"/></svg>';
  function move(strip, state, next) {
    const first = strip.firstElementChild;
    if (!first) return;
    const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(strip).columnGap);
    const maximum = strip.scrollWidth - strip.clientWidth;
    const current = Math.abs(strip.scrollLeft);
    const target = next ? (current >= maximum - 2 ? 0 : Math.min(maximum, current + step)) : Math.max(0, current - step);
    strip.scrollTo({ left: -target, behavior: reduced.matches ? 'instant' : 'smooth' });
  }
  function button(label, html, handler) {
    const result = document.createElement('button');
    result.type = 'button';
    result.setAttribute('aria-label', label);
    result.title = label;
    result.innerHTML = html;
    result.addEventListener('click', handler);
    return result;
  }
  function setup() {
    document.querySelectorAll('.template-index [id*="__featured_collection"] ul.grid:not(.swiper-wrapper)').forEach(strip => {
      if (strips.has(strip) || !strip.querySelector('.product-card-wrapper')) return;
      strip.classList.add('nab-product-strip');
      strip.tabIndex = 0;
      strip.setAttribute('aria-label', config.label);
      const state = { paused: reduced.matches, interaction: false, until: 0 };
      strips.set(strip, state);
      const controls = document.createElement('div');
      controls.className = 'nab-motion-controls';
      controls.append(button(config.previous, arrow('previous'), () => { state.until = Date.now() + 10000; move(strip, state, false); }));
      const toggle = button(state.paused ? config.play : config.pause, state.paused ? playIcon : pauseIcon, () => {
        state.paused = !state.paused;
        toggle.setAttribute('aria-label', state.paused ? config.play : config.pause);
        toggle.title = state.paused ? config.play : config.pause;
        toggle.innerHTML = state.paused ? playIcon : pauseIcon;
      });
      controls.append(toggle, button(config.next, arrow('next'), () => { state.until = Date.now() + 10000; move(strip, state, true); }));
      strip.after(controls);
      strip.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') state.interaction = true; });
      strip.addEventListener('pointerleave', () => { state.interaction = false; });
      strip.addEventListener('touchstart', () => { state.until = Date.now() + 10000; }, { passive: true });
      strip.addEventListener('wheel', () => { state.until = Date.now() + 10000; }, { passive: true });
      strip.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          state.until = Date.now() + 10000;
          move(strip, state, event.key === 'ArrowRight');
        }
      });
    });
    document.querySelectorAll('#MainContent [data-nab-product-images]').forEach(data => {
      if (pictures.has(data)) return;
      let images;
      try { images = JSON.parse(data.textContent); } catch { return; }
      const media = data.parentElement.querySelector('.card__media .media');
      const original = media?.querySelector('img');
      if (!original || images.length < 2) return;
      const front = original.cloneNode(false);
      front.removeAttribute('id');
      front.removeAttribute('srcset');
      front.removeAttribute('sizes');
      front.className = 'nab-rotating-image';
      front.src = original.currentSrc || original.src;
      const back = front.cloneNode(false);
      back.classList.add('nab-image-hidden');
      media.append(front, back);
      media.classList.add('nab-image-rotator');
      const index = Math.max(0, images.findIndex(image => image.src.split('?')[0] === front.src.split('?')[0]));
      pictures.set(data, { images, media, front, back, index, busy: false });
    });
  }
  async function changeImage(state) {
    if (state.busy) return;
    state.busy = true;
    const next = (state.index + 1) % state.images.length;
    state.back.src = state.images[next].src;
    state.back.alt = state.images[next].alt;
    try {
      await state.back.decode();
      if (!state.media.isConnected) return;
      state.back.classList.remove('nab-image-hidden');
      state.front.classList.add('nab-image-hidden');
      [state.front, state.back] = [state.back, state.front];
      state.index = next;
      state.media.dataset.nabImageIndex = String(next);
    } catch {} finally { state.busy = false; }
  }
  setup();
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; setup(); });
  }).observe(document.querySelector('#MainContent'), { childList: true, subtree: true });
  setInterval(() => {
    if (document.hidden) return;
    for (const [strip, state] of strips) {
      if (!strip.isConnected) { strips.delete(strip); continue; }
      if (!state.paused && !state.interaction && state.until < Date.now() && visible(strip) && !strip.contains(document.activeElement)) move(strip, state, true);
    }
    for (const [data, state] of pictures) {
      if (!data.isConnected) { pictures.delete(data); continue; }
      const strip = state.media.closest('.nab-product-strip');
      if (reduced.matches || strips.get(strip)?.paused || !visible(state.media) || state.media.closest('.card-wrapper')?.contains(document.activeElement)) continue;
      const rect = state.media.getBoundingClientRect();
      const parentRect = strip?.getBoundingClientRect();
      if (parentRect && (rect.right <= parentRect.left || rect.left >= parentRect.right)) continue;
      changeImage(state);
    }
  }, 5000);
})();
